import { registerPlugin } from '@capacitor/core';

export interface SaveToDownloadsOptions {
  /** `file://` path of the downloaded source file. */
  path: string;
  /** File name to use in the Downloads collection. */
  fileName: string;
  /** MIME type; falls back to the file extension when omitted. */
  mimeType?: string;
}

export interface Version {
  version: string;
}

/**
 * Android-only: copies a downloaded file into the public Downloads collection.
 */
export interface MediaStoreDownloadsPlugin {
  pluginVersion(): Promise<Version>;
  saveToDownloads(options: SaveToDownloadsOptions): Promise<void>;
}

export const MEDIA_STORE_DOWNLOADS_PLUGIN_NAME = 'MediaStoreDownloads';

export const mediaStoreDownloadsPlugin =
  registerPlugin<MediaStoreDownloadsPlugin>(MEDIA_STORE_DOWNLOADS_PLUGIN_NAME);
